import React from 'react';
import { withInjectedProps } from '../../../../../Core/InjectedPropsContext';
import { useSelector } from 'react-redux';
import { WorksheetGridFieldSection, WorksheetRecordGrid } from '../../../../Core';
import { Field, TextOutput, Checkbox } from '../../../../../Core';
import deepEquals from '../../../../../../Lib/Object/deepEquals';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import { pipe } from 'Lib/Hooks/Selectors';
import { prefixRecordFieldSetNames } from 'Components/Worksheets/Core/WorksheetRecordGrid/helpers';
import { getGridFieldSet as getMoistureContentGridFieldSet } from 'Components/Worksheets/MoistureContentWorksheet/Aashto/gridFieldSets';
import { createDryMassEntryOptionSelector } from 'Components/Worksheets/MoistureContentWorksheet';

let MetricCompactionWaterContentDeterminationGridSection: React.FC<IWorksheetComponent> = ({
  createWorksheetSelector,
}) => {
  const dryMassEntryOption = useSelector(createDryMassEntryOptionSelector(createWorksheetSelector!));

  const testPortionRecordProps = useSelector(
    pipe(createWorksheetSelector!('TestPortions'), (portions) =>
      (portions ?? []).map((p: any) => ({
        dim: p.ExcludedPoint,
      }))
    ),
    deepEquals
  );

  return (
    <WorksheetGridFieldSection name="TestPortions">
      <WorksheetRecordGrid
        name={'TestPortions'}
        orientation={'horizontal'}
        rowHeaderWidth={180}
        scrollLinkId="mddCompaction"
        recordProps={{
          width: 130,
          preventRemove: true, // Removed in another, related grid
          dim: (i) => testPortionRecordProps[i]?.dim,
          heading: 'number',
          headingLabel: 'Test Portion ID',
        }}
        fieldSet={[
          ...prefixRecordFieldSetNames('MoistureDetermination', getMoistureContentGridFieldSet(dryMassEntryOption)),
          {
            name: 'DryDensity',
            component: <Field input={<TextOutput />} />,
            label: 'Dry Density (kg/m³)', // Remove when labels migrated to config
          },
          {
            name: 'ExcludedPoint',
            component: <Field input={<Checkbox />} />,
            label: 'Exclude Point', // Remove when labels migrated to config
          },
        ]}
      />
    </WorksheetGridFieldSection>
  );
};

MetricCompactionWaterContentDeterminationGridSection = withInjectedProps(
  MetricCompactionWaterContentDeterminationGridSection
);

export { MetricCompactionWaterContentDeterminationGridSection };
export default MetricCompactionWaterContentDeterminationGridSection;
